import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { receiveFilterHauls, receiveFilterProjects } from '../Store/actions'
import CheckIcon from '@material-ui/icons/Check'

const Filters = props => {
  const { activeNow } = props
  const numFiltersApplied = activeNow.filters.hauls.length + activeNow.filters.projects.length

  const filterOnOff = (filterArr, clickedFilter, action) => {
    if (filterArr.includes(clickedFilter)) {
      action(filterArr.filter(filterHaul => filterHaul !== clickedFilter))
    } else {
      action([...filterArr, clickedFilter])
    }
  }

  return (
    <>
      <div style={{ padding: '16px', borderBottom: '1px solid var(--border-color-base)' }}>
        <div>
          <span style={{ color: '#6B6C70', fontSize: '16px' }}>Filter</span>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
          <span style={{ fontSize: '24px', color: '#3E3F42', fontWeight: '500' }}>
            Select Filters
          </span>
          {numFiltersApplied ? (
            <span style={{ fontSize: '12px', alignSelf: 'flex-end' }}>
              {numFiltersApplied + ' active'}
            </span>
          ) : null}
        </div>
      </div>

      <div style={{ padding: '20px 16px', borderBottom: '1px solid var(--border-color-base)' }}>
        <div>
          <span style={{ color: '#6B6C70', fontSize: '16px' }}>Projects</span>
        </div>

        <div style={{ marginTop: '10px' }}>
          {props.originalProjects.map((project, i) => (
            <div
              key={i}
              style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}
            >
              <div style={{ fontSize: '22px', color: '#3E3F42' }}>{project}</div>
              <div
                style={{
                  minWidth: '25px',
                  height: '25px',
                  minHeight: '25px',
                  background: '#FFFFFF 0% 0 % no - repeat padding- box',
                  border: '1px solid #BCBCBC',
                  borderRadius: '3px',
                  opacity: 1,
                  backgroundColor: activeNow.filters.projects.includes(project) ? '#B8D5FC' : null
                }}
                onClick={() =>
                  filterOnOff(activeNow.filters.projects, project, props.receiveFilterProjects)
                }
              >
                {activeNow.filters.projects.includes(project) ? (
                  <CheckIcon style={{ color: 'rgb(62, 63, 66)' }} />
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: '20px 16px' }}>
        <div>
          <span style={{ color: '#6B6C70', fontSize: '16px' }}>Hauls</span>
        </div>

        <div style={{ marginTop: '10px' }}>
          {props.originalHauls.map((haul, i) => (
            <div
              key={i}
              style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}
            >
              <div style={{ fontSize: '22px', color: '#3E3F42' }}>{haul}</div>
              <div
                style={{
                  minWidth: '25px',
                  height: '25px',
                  minHeight: '25px',
                  background: '#FFFFFF 0% 0 % no - repeat padding- box',
                  border: '1px solid #BCBCBC',
                  borderRadius: '3px',
                  opacity: 1,
                  backgroundColor: activeNow.filters.hauls.includes(haul) ? '#B8D5FC' : null
                }}
                onClick={() => filterOnOff(activeNow.filters.hauls, haul, props.receiveFilterHauls)}
              >
                {activeNow.filters.hauls.includes(haul) ? (
                  <CheckIcon style={{ color: 'rgb(62, 63, 66)' }} />
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  return {
    originalProjects: state.activeNow.projects,
    originalHauls: state.activeNow.hauls
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ receiveFilterHauls, receiveFilterProjects }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Filters)
